import { configureStore } from "@reduxjs/toolkit";
import socket from "features/socket/socketSlice";
import socketMiddleware from "features/socket/socketMiddleware";

export const store = configureStore({
    reducer: {
        socket,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(socketMiddleware)
})